import axios from "axios";

export const state = {
    feesbreakdowns: [],
};

export const getters = {
    feesbreakdowns: state => state.feesbreakdowns,
};

export const mutations = {
    setFeesBreakdowns(state, newValue) {
        state.feesbreakdowns = newValue
    },
};

export const actions = {
    fetchFeesBreakdowns({ commit }) {
        axios.get('/feesbreakdowns').then(res => {
            commit('setFeesBreakdowns', res.data.feesbreakdowns);
        })
    },
};
